import type { ReactNode } from 'react';
import styles from './Decision.module.css';

/**
 * Two buttons that answer one question, kept together. Section 9 of the request
 * of 16 September 2026.
 *
 * The client reported that one of Approve and Refuse drops to the next line.
 * It does, and so would Pass and Send to rework: the action rows wrap by
 * design, and two buttons with long labels beside a status pill exceed the row.
 * Wrapping is right for a row of actions and wrong for a decision, because an
 * Approve above its own Refuse reads as two separate decisions and a thumb on a
 * narrow row presses the wrong one.
 *
 * Wrap the pair, not each button, and let the pair wrap as a unit. Every dialog
 * footer has done this from the start, which is why nobody has reported Cancel
 * dropping below Confirm.
 */
export function Decision({ children, label }: { children: ReactNode; label?: string }) {
  return (
    <div className={styles.decision} role="group" aria-label={label}>
      {children}
    </div>
  );
}
